import IconListSolid from '@/assets/icons/font_awesome/list-solid.svg?react';
import IconTableCellsLargeSolid from '@/assets/icons/font_awesome/table-cells-large-solid.svg?react';
import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { use_slice_collections } from '@/hooks/store/use_slices';
import { LayoutPageMobileWithTabs } from '@/layouts/LayoutPageMobileWithTabs';
import { TabsContent } from '@radix-ui/react-tabs';
import { useState } from 'react';
import { GRID2D__master } from '../_base/grid2d/views/GRID2D__master';
import { C_SIDEBAR__collections } from './_bars/C_SIDEBAR__collections';

export function PageCollectionsViewsMobile() {
  const { collection_current } = use_slice_collections(['collection_current']);

  const [active_tab, set_active_tab] = useState(EPagesMobileTabs.COLLECTION_LIST);

  return (
    <>
      <LayoutPageMobileWithTabs
        tabs={[EPagesMobileTabs.COLLECTION_LIST, EPagesMobileTabs.GRID2D]}
        icons={[<IconListSolid />, <IconTableCellsLargeSolid />]}
        activeTab={active_tab}
        setActiveTab={set_active_tab}
      >
        <TabsContent className={`mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.COLLECTION_LIST}>
          <C_SIDEBAR__collections />
        </TabsContent>
        {/* <TopbarInfoSelectedCollection /> */}
        <TabsContent className={` mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.GRID2D}>
          <div className="w-full h-full text-center relative flex flex-col">
            <GRID2D__master entity_id={collection_current._id} entity_type={collection_current.type} />
          </div>
        </TabsContent>
      </LayoutPageMobileWithTabs>
    </>
  );
}
